import React, { Component } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Quill from 'quill';
import ImageResize  from 'quill-image-resize-module-react';
import VideoResize from 'quill-video-resize-module2';

import Layout4Admin1 from "components/layout/Layout4Admin1";
import Css from './Customer.module.css';
import { useEffect, useState } from "react";
import { Form, Button, Col, Row, Breadcrumb, InputGroup } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import ApiConection from "api_ref/ApiConection";
import { ConvertDateTimeToText, TextDate, ConvertDateToText,ConvertTimeToText, ButtonUploadFile } from "components/MyControl";
import Swal from "sweetalert2";
import moment from "moment";
import UtilClass from "api_ref/UtilClass";

export default function NewsNotificationsManagementDetail() {
    const nav = useNavigate();
    const api = new ApiConection();
    const { id } = useParams();
    const [validated, setValidated] = useState(false);
    const [alert, setAlert] = useState('');
    const [loading, setLoading] = useState(false);
    const [mode, setMode] = useState('view');
    const [createMode,setCreateMode] = useState(false);
    const [initialData, setInitialData] = useState({});
    const [simulate, setSimulate] = useState({});
    const [hour, setHour] = useState([]);
    const [minute, setMinute] = useState([]);

    const urlPathName = window.location.pathname;
    const utilcls = new UtilClass();
    const customer = utilcls.getSessionStorage('_dcaas_8089');

    const GetHour = () => {
        let data = [];
        for (let i = 0; i <= 23; i++) {
            let text = '00' + i;
            text = text.substr(text.length - 2, 2);
            data.push(text);
        }
        setHour(data);
    }

    const GetMinute = () => {
        let data = [];
        for (let i = 0; i < 60; i++) {
            let text = '00' + i;
            text = text.substr(text.length - 2, 2);
            data.push(text);
        }
        setMinute(data);
    }

    const getData = async () => {
        const response = await api.getData(`api/MailNewsNotification/${id}`);
        
        if (response.status === true) {

            let data = {}
            data.name = response.data.name;
            data.send_at = ConvertDateTimeToText(response.data.send_at);
            data.send_all =response.data.send_all;
            data.email_to = response.data.email_to;
            data.template_id = response.data.template_id;
            data.subject = response.data.subject; 
            data.content = response.data.content; 
            data.is_run = response.data.is_run; 
            data.run_at = ConvertDateTimeToText(response.data.run_at);
            data.count_success = response.data.count_success; 
            data.count_record = response.data.count_record; 
            data.active = response.data.active;
            data.create_date = response.data?.create_date;
            data.modify_date = response.data?.modify_date;
            data.modify_by = response.data?.modify_by;
            data.mail_news_notifications =  response.data?.mail_news_notifications ?? [];

            let send_at = moment(response.data?.send_at, 'YYYY-MM-DDTHH:mm:ss');
            if(send_at !== 'Invalid date'){
                data.send_date = send_at.format('DD/MM/YYYY');
                data.send_hour = send_at.format('HH');
                data.send_minute = send_at.format('mm');
            }
            setSimulate(data);
            setInitialData(data);
        }
    }

    const formats = [
    'header',
    'font',
    'size',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'color',
    'list',
    'bullet',
    'indent',
    'align',
    'link',
    'image',
    'video'
    ];
        
    Quill.register('modules/imageResize', ImageResize);
    Quill.register('modules/VideoResize', VideoResize);

    useEffect(() => {
        if (urlPathName === (process.env.PUBLIC_URL+'/manage-news-notifications/create')){
            setMode('edit');
            setCreateMode(true);
            let temp = simulate;
            temp.written_by = customer.show_name;
            setSimulate(temp)
        }
        
    },[urlPathName])


    useEffect(()=>{
        if(mode !== 'view'){
            if(simulate?.blog_body !== undefined)
            document.getElementsByClassName('ql-editor')[0].innerHTML = simulate?.blog_body
        }

    },[mode])

    useEffect(() => {
        GetHour();
        GetMinute();
        getData();
    }, [])

    

    const handleSetSimulate = async (event) => {
    
        const { name, value, checked, type ,files} = event.target;

       
            if(type === 'checkbox'){
                setSimulate(preData => { return { ...preData, [name]: checked } });
            }else  if (type === "file") {
                setSimulate((prevData) => {
                    return { ...prevData, [name]: files ? files[0] : undefined || value };
                });
            }else {
                setSimulate(preData => { return { ...preData, [name]: value } });
            }
     }

     const handleSetSimulateBodyBlog = async (name,value)=>{
        setSimulate(preData => { return { ...preData, [name]: value } 
        });
     }

    const handleBreadcrumbClick = (e) => {
        nav('/manage-news-notifications');
    };
    
    const handleCancel = (event) => {
        if (createMode) {
            nav('/manage-news-notifications'); 
        } else {
            setSimulate(initialData);
            setMode('view');
        }
    }
    

    const handleSubmit = async (event) => {
        const form = event.currentTarget;
        event.preventDefault();

        setValidated(false);
        setAlert('');
        setLoading(true);

        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
            setLoading(false);
            return;
        }

        let send_date = moment(simulate.send_date + ' ' + simulate.send_hour + ":" + simulate.send_minute, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DDTHH:mm:ss');

        let data = {
            name : simulate.name,
            send_all : simulate.send_all ?? false,
            email_to : simulate.email_to,
            template_id : simulate.template_id,
            subject : simulate.subject,
            content : simulate.content,
            active : simulate.active ?? false,
            create_date : simulate?.create_date,
            modify_date : simulate?.modify_date,
            modify_by : simulate?.modify_by,
        }

        if(send_date !== 'Invalid date'){
            data.send_at = send_date;
        }

        if (urlPathName === (process.env.PUBLIC_URL+'/manage-news-notifications/create')){
            const response = await api.postData(`api/MailNewsNotification`, data)
            if (response.status === true) {

                nav('/manage-news-notifications');
            } else{
                setAlert(response.message);
            }
        } else {
            const response = await api.putData(`api/MailNewsNotification/${id}`, data);

            if (response.status === true) {
                Swal.fire({title:'บันทึกสำเร็จ', icon:'success',heightAuto: false});
                await getData();
                setMode('view');
            } else {
                Swal.fire({title:'บันทึกไม่สำเร็จ', icon:'error',heightAuto: false});
                setAlert(response.message);
                setMode('edit');
            }
        }

        ////------------- หลัง่บันทึกเสร็จแล้ว ค่อยบันทึก รูป
        

        setLoading(false);
    }


    const handleDelete = (id) => {
        Swal.fire({
            title: 'ต้องการลบข้อมูลผู้ใช้ ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0d6efd',
            cancelButtonColor: '#727a82',
            cancelButtonText: 'ยกเลิก',
            confirmButtonText: 'ตกลง',
            heightAuto: false,
          }).then((result) => {
            if (result.isConfirmed) {
                api.deleteData(`api/MailNewsNotification/${id}`)
                .then((response) => {
                    if (response.status === true) {
                        Swal.fire('ลบสำเร็จ', '', 'success');
                        nav('/manage-news-notifications');
                    } else {
                        Swal.fire('เกิดข้อผิดพลาด', '', 'error');
                    }
                })
            }
        })
    }

    return (
        <Layout4Admin1>
            <div className={Css.Block_Transparent}>
                <div className='contrainermt-3 mb-3'>
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={handleBreadcrumbClick}>จัดการข่าวสารและการแจ้งเตือน</Breadcrumb.Item>
                        <Breadcrumb.Item active>
                            {
                                mode === 'view' ? 'รายละเอียดข่าวสารและการแจ้งเตือน' :
                                createMode === true ? 'สร้างข่าวสารและการแจ้งเตือน' :
                                'แก้ไขข่าวสารและการแจ้งเตือน'
                            }
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <Form noValidate validated={validated} onSubmit={event => handleSubmit(event)} >
                        <div className={`border rounded p-4 bg-white shadow w-100`}>
                            <div>
                                <Row>
                                    <Col>
                                        <h5 className='text-start mb-0'>
                                            {
                                                mode === 'view' ? 'รายละเอียดข่าวสารและการแจ้งเตือน' :
                                                createMode === true ? 'สร้างข่าวสารและการแจ้งเตือน' :
                                                'แก้ไขข่าวสารและการแจ้งเตือน'
                                            }
                                        </h5>
                                    </Col>
                                    <Col className='text-end'>
                                        {
                                            mode === 'view' &&
                                            <Button variant="outline-secondary" type="button" className=''
                                                onClick={event => setMode('edit')}>
                                                แก้ไข
                                                <i className="ms-2 fa-solid fa-pencil"></i>
                                            </Button>
                                        }
                                    </Col>
                                    
                                </Row>
                            </div>
                            <div className="mt-5">
                                <Row className='mb-5'>
                                    <Col className='me-3'>
                                            <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>ชื่อ<span className='text-danger'>*</span></Form.Label>
                                                <Form.Control type={'text'}
                                                    plaintext={(mode === 'view') ? true : false}
                                                    readOnly={(mode === 'view') ? true : false}
                                                    className=''
                                                    name={'name'}
                                                    value={simulate?.name}
                                                    onChange={handleSetSimulate}
                                                    placeholder="name" 
                                                    required={true} />
                                            </Form.Group>
                                            <Form.Group>
                                                {
                                                    mode === 'view'  &&
                                                    <>
                                                    <Row className='mb-2 '>
                                                        <Form.Label className='label-title'>วันที่-เวลา ส่งข่าวสารและแจ้งเตือน</Form.Label>
                                                        <Form.Label className={Css.colorfont}>{simulate?.send_at}</Form.Label>
                                                    </Row>
                                                    </>
                                                }
                                                {
                                                mode !== 'view' &&
                                                <>
                                                <Row className='mb-2 '>
                                                    <Col>
                                                        <Form.Label className='label-title'>วันที่ ส่งข่าวสารและแจ้งเตือน</Form.Label>
                                                        <TextDate name={'send_date'} value={simulate?.send_date} onChange={event => handleSetSimulate(event)} required={true} />
                                                    
                                                    </Col>
                                                    <Col>
                                                        <Form.Label className='label-title'>เวลาที่ส่งข่าวสารและแจ้งเตือน</Form.Label>
                                                        <InputGroup>
                                                            <Form.Select name={'send_hour'} className='border-end-0' value={simulate?.send_hour} onChange={event => handleSetSimulate(event)} required={true}>
                                                                {
                                                                    hour.map((obj, index) => {
                                                                        return (
                                                                            <option key={index} value={obj}>{obj}</option>
                                                                        )
                                                                    })
                                                                }
                                                            </Form.Select>
                                                            <InputGroup.Text className='bg-white p-2'>:</InputGroup.Text>
                                                            <Form.Select name={'send_minute'} className='border-start-0 border-end-0' value={simulate?.send_minute} onChange={event => handleSetSimulate(event)} required={true}>
                                                                {
                                                                    minute.map((obj, index) => {
                                                                        return (
                                                                            <option key={index} value={obj}>{obj}</option>
                                                                        )
                                                                    })
                                                                }
                                                            </Form.Select>
                                                            <InputGroup.Text className='bg-white'><i className="fa-regular fa-clock"></i></InputGroup.Text>
                                                        </InputGroup>
                                                    </Col>
                                                </Row>
                                                </>
                                                }
                                            
                                            </Form.Group>
                                            <Form.Group className='mb-3'>
                                                <Form.Label className='label-title'>การส่งถึงผู้รับอีเมล<span className='text-danger'>*</span></Form.Label>
                                                <Form.Check type="switch" id={'send_all'} name={'send_all'} checked={simulate?.send_all} disabled={(mode === 'view') ? true : false}  
                                                onChange={handleSetSimulate} label={(simulate?.send_all == true) ? 'ส่งถึงลูกค้าทุกคนที่ active' : 'ส่งบางคน'}/>
                                        
                                            </Form.Group>
                                            <Form.Group className='mb-3'>
                                                <Form.Label className='label-title'>อีเมล {simulate?.send_all === false ? <span className='text-danger'>*</span> : ''}</Form.Label>
                                                <Form.Control name={'email_to'} plaintext={(mode === 'view') ? true : false}
                                                    readOnly={(mode === 'view') ? true : false} 
                                                    value={simulate?.email_to} onChange={handleSetSimulate} required={simulate?.send_all === false}/>
                                            </Form.Group>
                                            <Form.Group className='mb-3'>
                                                <Form.Label className='label-title'>หัวเรื่องอีเมล<span className='text-danger'>*</span></Form.Label>
                                                <Form.Control name={'subject'} plaintext={(mode === 'view') ? true : false}
                                                    readOnly={(mode === 'view') ? true : false} 
                                                    value={simulate?.subject} onChange={handleSetSimulate} required={true}/>
                                            </Form.Group>
                                                                           
                                        </Col>
                                    <Col className="me-3">
                                        <Form.Group as={Row} className="mb-3">
                                            <Form.Label className="label-title">วันที่สร้าง</Form.Label>
                                            <Form.Label>{ConvertDateTimeToText(simulate?.create_date)}</Form.Label>
                                        </Form.Group>

                                        {
                                            createMode === false &&
                                            <Form.Group as={Row} className="mb-3">
                                                <Form.Label className="label-title">วันที่แก้ไขล่าสุด</Form.Label>
                                                <Form.Label>{ConvertDateTimeToText(simulate?.modified_date)}</Form.Label>
                                            </Form.Group>
                                            
                                        }

                                        {
                                            createMode === false &&
                                            <Form.Group as={Row} className="mb-3">
                                                <Form.Label className="label-title">แก้ไขโดย</Form.Label>
                                                <Form.Label>{simulate?.modify_by}&nbsp;</Form.Label>
                                            </Form.Group>
                                        }
                                    <Form.Group className='mb-3'>
                                        <Form.Label className='label-title'>Active</Form.Label>
                                        <Form.Check type={'switch'}
                                            id={'active'}
                                            name={'active'}
                                            disabled={(mode === 'view') ? true : false}
                                            onChange={event => handleSetSimulate(event)}
                                            checked={simulate?.active}
                                            label={(simulate?.active == true) ? 'อนุญาต' : 'ไม่อนุญาต'}
                                        />
                                    </Form.Group>
                                    </Col>
                                    <Form.Group className='mb-3'>
                                        <Form.Label className='label-title'>เนื้อหาอีเมล</Form.Label>
                                        {
                                            mode === 'view' &&
                                            <div id='article_id' className='shadow' style={{ padding: '20px'}}  dangerouslySetInnerHTML={{ __html: simulate?.content?.replace(/  /gi,'&nbsp;') }} /> 
                                        }
                                        {
                                            (createMode === true || mode !== 'view')  &&
                                            <div>
                                            <ReactQuill
                                                name='content'
                                                theme="snow" 
                                                readOnly={mode === 'view'}
                                                value={simulate?.content}
                                                onChange={event => handleSetSimulateBodyBlog('content',event)}
                                                formats={formats}
                                                modules={{
                                                    imageResize: {
                                                        parchment: Quill.import('parchment'),
                                                        modules: ['Resize', 'DisplaySize']
                                                    },
                                                    VideoResize: {
                                                        modules: [ 'Resize', 'DisplaySize' ],
                                                        tagName: 'iframe', 
                                                    },
                                                    toolbar: [
                                                      [{ 'header': [1, 2, 3, false] }],
                                                      [{ size: [] }],
                                                      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                                      [{ 'color': [] }, { 'background': [] }],  
                                                      [{'list': 'ordered'}, {'list': 'bullet'}],  
                                                      [{ 'indent': '-1'}, { 'indent': '+1' }],
                                                      [{ 'align': null}, {'align': 'center'}, {'align': 'right'}, {'align': 'justify'}],
                                                      ['link', 'image', 'video'],
                                                      ['clean']
                                                    ],
                                                }}
                                            />
                                        </div>
                                        }
                                    </Form.Group>
                                    <p>*หมายเหตุ: ใช้สัญลักษณ์เหล่านี้ เพื่อแทนข้อมูล, &#123;0&#125; = ชื่อลูกค้า, &#123;1&#125; = ชื่อบริษัท, &#123;2&#125; = ที่อยู, &#123;3&#125; = เลขประจำตัวผู้เสียภาษี, &#123;4&#125; = ชื่อไซต์</p>
                                </Row>
                            </div>

                            <Col className='text-end'>
                                {
                                    mode === 'view' &&
                                    <Button variant="outline-danger" type="button" className=''
                                        onClick={event => handleDelete(id)}>
                                        ลบ
                                        <i className="ms-2 fa-solid fa-trash"></i>
                                    </Button>
                                }
                            </Col>

                            {
                                alert != '' &&
                                <div className="alert alert-danger" role="alert">
                                    {alert}
                                </div>
                            }

                            {
                            <Row>
                                <Col>
                                    {createMode && (
                                        <>
                                            <Button variant="outline-secondary" type="button" className='ps-5 pe-5 me-1'
                                                onClick={handleCancel}  >
                                                ยกเลิก
                                            </Button>
                                            <Button variant="primary" type="submit" className='ps-5 pe-5' >
                                                สร้าง
                                                {loading === true && (
                                                    <div className="spinner-border spinner-border-sm text-light ms-2" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                )}
                                            </Button>
                                        </>
                                    )}
                                    {!createMode && mode === 'edit' && (
                                        <>
                                            <Button variant="outline-secondary" type="button" className='ps-5 pe-5 me-1'
                                                onClick={handleCancel}  >
                                                ยกเลิก
                                            </Button>
                                            <Button variant="primary" type="submit" className='ps-5 pe-5' >
                                                บันทึก
                                                {loading === true && (
                                                    <div className="spinner-border spinner-border-sm text-light ms-2" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                )}
                                            </Button>
                                        </>
                                    )}
                                </Col>
                            </Row>
                            }
                        </div>
                        {
                            simulate?.mail_news_notifications?.length > 0 &&
                            <div className={`border rounded p-4 bg-white shadow w-100 mt-3`}>
                                <h4>รายการอีเมลที่ส่ง</h4>
                                <div className='table-responsive mt-5'>
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>อีเมล</th>
                                                <th>สถานะส่ง</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                            simulate?.mail_news_notifications?.map((obj,index)=>(
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{obj.email_to}</td>
                                                    <td>
                                                        {
                                                            obj.send_status === 'Waiting' &&<span className="status yellow">รอส่งข้อความ</span>
                                                        }
                                                        {
                                                            obj.send_status === 'Success' &&<span className="status green">ส่งข้อความแล้ว</span>
                                                        }
                                                        {
                                                            obj.send_status === 'Fail' &&<span className="status red">ส่งข้อความแล้ว</span>
                                                        }

                                                    </td>
                                                </tr>
                                            ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }
                        
                    </Form>
                </div>
            </div>
        </Layout4Admin1>
    )
}